import { render } from "./TreatmentDetailPage.vue?vue&type=template&id=4bf64ce0&scoped=true"
import script from "./TreatmentDetailPage.vue?vue&type=script&lang=js"
export * from "./TreatmentDetailPage.vue?vue&type=script&lang=js"

import "./TreatmentDetailPage.vue?vue&type=style&index=0&id=4bf64ce0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf64ce0"]])

export default __exports__